import { useAppSelector } from "../hooks";
import { Navigate, Route, Routes } from "react-router-dom";
import { LoginPage } from "../features/auth/pages";
import { CustomLayout } from "../components/custom-layout";
import { InfosClientPage, ListClient } from "../features/infos-client/pages";
import clientRoutes from "../constants/clientRoutes";
import {
  CommandesPage,
  ListCommandePageRepresentant,
  ListPreCommandePageRepresentant,
} from "../features/commandes/pages";
import { ChangePasswordPage } from "../features/change-password/pages";
import {
  PreOrderDetailsPage,
  PreOrdersPage,
} from "../features/pre-commandes/pages";

import { IsAuthorizedRoles } from "../components/auth";
import Roles from "../constants/roles";
import adminRoutes from "../constants/adminRoutes";
import { ObjectivesPage } from "../features/objectives/pages";
import { RepresentantSitesPage } from "../features/administration/pages";
import salesRepresentativeRoutes from "../constants/salesRepresentativeRoutes";
import PreCommandesPage from "../features/pre-commandes/pages/PreCommandePage";

const PublicRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

const ProtectedRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<CustomLayout />}>
        <Route
          index
          element={
            <>
              <IsAuthorizedRoles roles={[Roles.REPRESENTATIVE]}>
                <PreCommandesPage />
              </IsAuthorizedRoles>
              <IsAuthorizedRoles roles={[Roles.CLIENT]}>
                <InfosClientPage />
              </IsAuthorizedRoles>
              <IsAuthorizedRoles roles={[Roles.ADMIN]}>
                <PreOrdersPage />
              </IsAuthorizedRoles>
            </>
          }
        />
        <Route
          path={salesRepresentativeRoutes.NEW_PREORDER}
          element={
            <IsAuthorizedRoles roles={[Roles.REPRESENTATIVE]}>
              <PreCommandesPage />
            </IsAuthorizedRoles>
          }
        />
        <Route
          path={salesRepresentativeRoutes.LIST_CLIENTS}
          element={
            <IsAuthorizedRoles roles={[Roles.REPRESENTATIVE]}>
              <ListClient />
            </IsAuthorizedRoles>
          }
        />
        <Route
          path={salesRepresentativeRoutes.INFOS_CLIENTS_REPRESENTANT}
          element={
            <IsAuthorizedRoles roles={[Roles.REPRESENTATIVE]}>
              <InfosClientPage />
            </IsAuthorizedRoles>
          }
        />
        <Route
          path={salesRepresentativeRoutes.LIST_PRE_COMMANDES}
          element={
            <IsAuthorizedRoles roles={[Roles.REPRESENTATIVE]}>
              <ListPreCommandePageRepresentant />
            </IsAuthorizedRoles>
          }
        />
        <Route
          path={salesRepresentativeRoutes.LIST_COMMANDES}
          element={
            <IsAuthorizedRoles roles={[Roles.REPRESENTATIVE]}>
              <ListCommandePageRepresentant />
            </IsAuthorizedRoles>
          }
        />
        <Route
          path={clientRoutes.INFOS_CLIENT}
          element={
            <IsAuthorizedRoles roles={[Roles.CLIENT]}>
              <InfosClientPage />
            </IsAuthorizedRoles>
          }
        />

        <Route
          path={clientRoutes.ORDERS}
          element={
            <IsAuthorizedRoles roles={[Roles.CLIENT]}>
              <CommandesPage />
            </IsAuthorizedRoles>
          }
        />
        <Route
          path={adminRoutes.PRE_ORDERS}
          element={
            <IsAuthorizedRoles roles={[Roles.ADMIN]}>
              <PreOrdersPage />
            </IsAuthorizedRoles>
          }
        />
        <Route
          path={adminRoutes.PRE_ORDER_DETAILS}
          element={
            <IsAuthorizedRoles roles={[Roles.ADMIN]}>
              <PreOrderDetailsPage />
            </IsAuthorizedRoles>
          }
        />
        <Route
          path={adminRoutes.REPRESENTANT_SITES}
          element={
            <IsAuthorizedRoles roles={[Roles.ADMIN]}>
              <RepresentantSitesPage />
            </IsAuthorizedRoles>
          }
        />
        {/* <Route
          path={adminRoutes.OBJECTIVES}
          element={
            <IsAuthorizedRoles roles={[Roles.ADMIN]}>
              <ObjectivesPage />
            </IsAuthorizedRoles>
          }
        /> */}

        <Route
          path={`${salesRepresentativeRoutes.CHANGE_PASSWORD}`}
          element={<ChangePasswordPage />}
        />
      </Route>
    </Routes>
  );
};

const MainRoute = () => {
  const { roles } = useAppSelector((state) => state.authSlice);
  const isLogged = useAppSelector((state) => state.authSlice.isLogged);

  return isLogged ? <ProtectedRoutes /> : <PublicRoutes />;
};

export default MainRoute;
